import React from "react";
import clsx from "clsx";

import { Text, View } from "../base";
import { Icon } from "../base/Icon";

type AdminStatTileProps = {
  icon: string;
  iconColorClass: string;
  label: string;
  value: React.ReactNode;
  delta?: string | null;
  onClick?: () => void;
  isLoading?: boolean;
};

export const AdminStatTile = ({ icon, iconColorClass, label, value, delta, onClick, isLoading }: AdminStatTileProps) => (
  <div
    onClick={onClick}
    className={clsx(
      "rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-slate-900 p-4",
      onClick && "cursor-pointer transition-colors hover:border-gray-300 dark:hover:border-gray-700",
    )}
  >
    <View className="flex flex-row items-center gap-1.5 mb-2">
      <Icon
        name={icon}
        size={14}
        className={clsx("shrink-0", iconColorClass)}
      />
      <Text className="text-xs font-medium uppercase tracking-wider text-gray-400 dark:text-gray-500 truncate">{label}</Text>
    </View>
    {isLoading ? (
      <div className="h-8 w-20 animate-pulse rounded bg-gray-100 dark:bg-gray-800" />
    ) : (
      <Text className="block text-2xl font-semibold tabular-nums text-gray-900 dark:text-white">{value}</Text>
    )}
    {!isLoading && delta && <Text className="block text-xs text-gray-400 mt-0.5">{delta}</Text>}
  </div>
);
